import React, { useEffect, useState } from 'react';
import { generatePath, useNavigate } from "react-router-dom";

import reactWrapper from "@harbor/elements/utils/react/wrapper";
import css from "../common/anomalyMagneticStyle.less";
import AppHoc from '../../../../../generics/AppHOC';
import ADChartView from './ADChartView';
import { PropTypes } from 'prop-types';
import { reloadQSI } from "../../../../../utils/common";
import useI18n from '../../../../../i18n/useI18n';
import { routeURLs } from '../../../../../utils/enums';

const [ HbrRadioButton, HbrViewSwitcher, HbrTooltip, HbrIconButton ]
    = reactWrapper(["hbr-radio-button", "hbr-view-switcher", "hbr-tooltip", "hbr-icon-button"]);

// For Qualtrics embedded data set the default tunnel to topTunnel
window._va_ad_tunnel_site_type = "topSites";

const ADSites = (props) => {
    const { tViews } = useI18n('views')
    const navigate = useNavigate();
    let selectedSiteId = props.globalFilter.selectedSite
    const [selectedSite, setSiteSelection] = useState("topSites");

    const handleSiteChange = (event) => {
        setSiteSelection(event.currentTarget.value);
        reloadQSI();
        window._va_ad_tunnel_site_type = event.currentTarget.value;
    };

    useEffect(() => {
        window.scrollTo(0, 0, "smooth");
        reloadQSI();
    }, []);

    useEffect(() => {
        if(selectedSiteId !== -1)
            navigate(generatePath(routeURLs.adSingleSite, { siteName: selectedSiteId }));
    }, [selectedSiteId])

    return (
        <div>
            <div className={css["anomaly-detection-widget"]}
                role="region"
                aria-label={tViews('a11yLabels.anomalyDetectionWidget')}>
                <>
                    <div style={{ display: "flex", position: "relative", zIndex: 0 }}>
                    <HbrViewSwitcher className="siteGroup"
                        value={selectedSite}
                        onHbr-change={handleSiteChange} 
                        aria-label={tViews('a11yLabels.sitegroup')}
                        role="radiogroup">
                        <HbrRadioButton
                            key="topSites"
                            id="topSites"
                            value="topSites"
                            aria-label={tViews('a11yLabels.topSites')}
                            aria-checked={selectedSite === "topSites"}
                        >
                            {tViews('predictiveNetworks.topUsedSitesTitle')}
                        </HbrRadioButton>
                        <HbrRadioButton
                            key="allSites"
                            id="allSites"
                            value="allSites"
                            aria-label={tViews('a11yLabels.allSites')}
                            aria-checked={selectedSite === "allSites"}
                        >
                            {tViews('predictiveNetworks.allUsedSitesTitle')}
                        </HbrRadioButton>
                    </HbrViewSwitcher>
                    <span className={"anomaly-detection-widget-tooltip"}>
                        <HbrTooltip hoist>
                        <div slot="content">
                            <span className="info-title">{`${tViews('predictiveNetworks.topUsedSitesTitle')}:`} </span>
                            <span>{tViews('predictiveNetworks.topUsedSites')}</span></div>
                        <div slot="content"> <span className="info-title">{`${tViews('predictiveNetworks.allUsedSitesTitle')}:`} </span>
                            <span>{tViews('predictiveNetworks.allUsedSites')}</span></div>
                        <HbrIconButton noPadding={true} name="info" sentiment="neutral"/>
                        </HbrTooltip>
                    </span>
                    <div id="va-ad-kpi-qualtrics-container">
                        {/* The Qualtrics Thumbs Up and Thumbs Down survey widget for the AD 1st page is rendered here */}
                    </div>
                    </div>
                    <div aria-live="polite">
                    <ADChartView selectType={selectedSite}/>
                    </div>
                </>
            </div>
        </div>
    )
}

ADSites.propTypes = {
    globalFilter: PropTypes.object,
    setSelectedSite: PropTypes.func
}

export default AppHoc(ADSites);
